export function formatLocaleDate(
  value: string | number | Date | null | undefined,
): string {
  if (value == null || value === '') {
    return '—';
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString();
}
